<template>
  <span class="rf-icon" aria-hidden="true">
    <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24">
      <path
        fill="none"
        stroke="inherit"
        stroke-width="1.25"
        d="M12 20.33a8.33 8.33 0 1 0 0-16.66 8.33 8.33 0 0 0 0 16.66Z"
      />
      <path
        fill="none"
        stroke="inherit"
        stroke-linecap="round"
        stroke-width="1.25"
        d="m14.08 9.92-4.16 4.16m0-4.16 4.16 4.16"
      />
    </svg>
  </span>
</template>
